import { defineMessages } from 'react-intl';

export default defineMessages({
  recapPageTitle: {
    id: 'recap_page.title',
  },
  managerRecapPageRejectButton: {
    id: 'manager_recap_page_reject_button.title',
  },
  managerRecapPageValidationtButton: {
    id: 'manager_recap_page_validation_button.title',
  },
  managerRecapPageValidationSagisButton: {
    id: 'manager_recap_page_validate_sagis.title',
  },
  managerRecapPageValidateBawabaButton: {
    id: 'manager_recap_page_validate.title',
  },
  managerRecapPageDecisionButton: {
    id: 'manager_recap_page_decision_button.title',
  },
  managerRecapPageRejectionTitle: {
    id: 'manager_recap_page_rejection.title',
  },
  save: {
    id: 'saham_dialog.save',
  },
  cancel: {
    id: 'saham_dialog.cancel',
  },
  managerRecapPageRejectionOtherReason: {
    id: 'manager_recap_page_rejection.other_reason',
  },
  managementMode: {
    id: 'manager_recap_validation_drawer.management_mode',
  },
  validationDrawerSubTitle: {
    id: 'saham_drawer.validation.sub_title',
  },
  fraudeTitle: {
    id: 'preopening_page.fraude.title',
  },
  validationDrawerTitle: {
    id: 'saham_drawer.validation.title',
  },
  responsibility: {
    id: 'saham_drawer.validation.responsibility',
  },
  comment: {
    id: 'saham_drawer.validation.comment',
  },
  circumstance: {
    id: 'saham_drawer.validation.circumstance',
  },
  scaleCase: {
    id: 'saham_drawer.validation.scale_case',
  },
  claimInformationModificationDrawerTitle: {
    id: 'saham_drawer.claim_information_modification_drawer.title',
  },
  circumstanceDetail: {
    id: 'saham_drawer.validation.circumstance_detail',
  },
  validatedStatus: {
    id: 'recap_page.claim_status.validated',
  },
  rejectedStatus: {
    id: 'recap_page.claim_status.rejected',
  },
  pendingStatus: {
    id: 'recap_page.claim_status.pending',
  },
  pendingInfoValidation: {
    id: 'recap_page.claim_status.pending_info_validation',
  },
  rejectSuccessMessage: {
    id: 'rejection_drawer.rejection_success_message',
  },
  validationSuccessMessage: {
    id: 'validation_drawer.validation_success_message',
  },
  drawerConfirmButtonTitle: {
    id: 'saham_drawer.validation.validate',
  },
  drawerSaveFormButtonTitle: {
    id: 'saham_drawer.manager_recap_page.update_form.save',
  },
  successDialogMessage: {
    id: 'recap_manager_page.open_claim_success_dialog.message',
  },
  successDialogAssignToSubService: {
    id: 'recap_manager_page.open_claim_success_dialog.assign_to_sub_service',
  },
  successDialogGoBackToHomePage: {
    id: 'recap_manager_page.open_claim_success_dialog.go_back_to_home_page',
  },
  assignmentDialogTitle: {
    id: 'assignment_dialog.title',
  },
  assignmentDialogAssignToSubService: {
    id: 'assignment_dialog.assign_to_sub_service',
  },
  assignmentDialogValidationButton: {
    id: 'assignment_dialog.validation_button',
  },
  assignmentDialogCancelButton: {
    id: 'assignment_dialog.cancel_button',
  },
  assignmentDialogAssignLawyer: {
    id: 'assignment_dialog.assign_lawyer',
  },
  validationMixedSinistreSubtitle: {
    id: 'saham_drawer.validation.mixed_sinistre.sub_title',
  },
  yes: {
    id: 'preopening_page.claim_information.yes',
  },
  no: {
    id: 'preopening_page.claim_information.no',
  },
  confirmationPreopening: {
    id: 'saham_drawer.validation.confirmation_preopening',
  },
  firmReference: {
    id: 'fee_note.firm_reference',
  },
  dialogDecisionTitle: {
    id: 'victim.decision_dialog.title',
  },
  validate: {
    id: 'victim.decision_dialog.action_validate',
  },
  reject: {
    id: 'victim.decision_dialog.action_reject',
  },
  successDialogAddVictims: {
    id: 'add_victims_success',
  },
  successDialogAddVehicle: {
    id: 'add_vehicle_success',
  },
  reason: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.contestation_drawer_withdrawal_reason',
  },
  decisionValidationToast: {
    id: 'add_validation_success',
  },
  assignmentDialogAssignMultipleLawyers: {
    id: 'assignment_dialog.assign_multiple_lawyers',
  },
  assignmentLawyerWarning: {
    id: 'legal_proceeding_page.reassignment_warning',
  },
  assignmentCivilJudiciaryProcessLawyerWarning: {
    id: 'legal_proceeding_page.reassignment_civil_judiciary_process_warning',
  },
  editProvisionIntervenantDialogTitle: {
    id: 'edit_provision_intervenant_message',
  },
  editProvisionIntervenant: {
    id: 'edit_provision_intervenant_name_message',
  },
  editProvisionIntervenantAmount: {
    id: 'edit_provision_intervenant_amount_message',
  },
  editProvisionIntervenantSuccessMessage: {
    id: 'edit_provision_intervenant_success_message',
  },
  errorLockedClaim: {
    id: 'error.claim_is_locked_error',
  },
  fraudMotifRequiredTitle: {
    id: 'prepopening_page.fraud_motif_required_title',
  },
  fraudVictimsRequiredTitle: {
    id: 'prepopening_page.fraud_victims_required_title',
  },
  fraudMotifOpposingLawyer: {
    id: 'prepopening_page.fraud_motif_opposing_lawyer_required_title',
  },
  lossDateValidationMessageCorporealPending: {
    id: 'recap_manager_page.open_claim_loss_date_validation_message_corporeal',
  },
  lossDateValidationMessageCorporealRejected: {
    id:
      'recap_manager_page.open_claim_loss_date_validation_message_corporeal_rejected',
  },
  lossDateValidationMessageSagisCorpo: {
    id:
      'recap_manager_page.open_claim_loss_date_validation_message_sagis_corporeal',
  },
  lossDateValidationMessageSagisMateriel: {
    id:
      'recap_manager_page.open_claim_loss_date_validation_message_sagis_materiel',
  },
  lossDateValidationMessagePolicy: {
    id: 'recap_manager_page.open_claim_loss_date_validation_message_policy',
  },
  lossDateValidationMessageSagisMixte: {
    id:
      'recap_manager_page.open_claim_loss_date_validation_message_sagis_mixte',
  },
  invalidDate: {
    id: 'preopening_page.invalid_date',
  },
  FeeNoteTitle: {
    id: 'side_bar.fee_note',
  },
  provisionTab: {
    id: 'court_manager_legal_proceedings_page.provision_tab.title',
  },
  courtManagerRecapTitle: {
    id: 'court_manager_legal_proceedings_page.recap_tab.title',
  },
  availabilityItt: {
    id: 'preopening_page.victim.availability_itt',
  },
  classKeyValidationClaim: {
    id: 'victim.class_key.validation_claim',
  },
  birthDateValidationClaim: {
    id: 'victim.birth_date.validation_claim',
  },
  lastValidation: {
    id: 'timeline_history.drawer.last_validation',
  },
  statusPendingApproval: {
    id: 'manager_recap_page_validated.title',
  },
  confirmCompletionDialog: {
    id: 'opening_manager.confirmation.dialog.description',
  },
  titleDialogCompletion: {
    id: 'opening_manager.confirmation.title',
  },
  dialogValidationButton: {
    id: 'assignment_dialog.validation_button',
  },
  dialogCancelButton: {
    id: 'assignment_dialog.cancel_button',
  },
  successValidationCompletionClaim: {
    id: 'completion_claim.success.title',
  },
  validationSexVictim: {
    id: 'victim.sex.validation_claim',
  },
});
